let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bdUIz")).then(() => parcelRequire('kF7iq'));